import React from 'react';
import appLogo from './logo.png';

const Logo = () => (
  <div className="logo">
    <img src={appLogo} alt="logo" />
  </div>
);

export default Logo;
